<template>
    <section class="font-poppins">
        <div class="flex justify-between mb-20">
            <div class="w-2/3 md:w-full p-2">
                <div class="flex justify-between mt-8">
                    <router-link to="/"><img class="md:w-1/2 w-4/5 pl-3"  src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo"></router-link>
                    <p class="mr-10 text-blue-600 text-2xl md:text-sm">3/4</p>
                </div>

                <div class="flex justify-center">
                    <div>
                        <div class="text-4xl mt-10 flex justify-content-center">
                            <h2 class="text-blue-600 font-semibold md:text-lg" style="color:rgb(18,84,179)">Sign Up as a DSP Carrier</h2>
                        </div>
                        <div class="w-4/5 md:w-full">
                            <div class="mt-8 font-semibold">
                                <p>Personal Information</p>
                            </div>
                            <div class="mt-5">
                                <form @submit.prevent="submitDetails">
                                    <div>
                                        <select name="dso-rider" id="dso-rider" class="p-2 pl-2 w-full rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179) " @change="onSelectedDso($event)">
                                            <option selected value="" disabled>---Select your DSP---</option>
                                            <option v-for="dso in dsos.sort(compareName)" :key="dso"  >
                                                <span v-if="dso.carrierMode === 'CabHailing' "> {{dso.firstName}} {{dso.lastName}}</span>
                                                <span v-else-if="dso.carrierMode === 'Dispatch'">{{dso.companyName}} {{dso.firstName}} {{dso.lastName}}</span>
                                                <span v-else>{{dso.companyName}} {{dso.firstName}} {{dso.lastName}}</span>
                                            </option>
                                        </select>
                                         <p v-if="selectedDsoValidity === 'invalid'" class=" text-xs text-red-500">Please select your Dso. </p>
                                    </div>
                                    <div class="mt-4">
                                        <input class="p-2 pl-2 w-full rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179) " type="text" name="firstName" id="firstName" placeholder="First Name" v-model="firstName"> <br>
                                        <p v-if="firstNameValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>
                                    <div>
                                        <input class="mt-4 w-full p-2 pl-2 rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)" type="text" name="lastName" id="LastName" placeholder="Last Name" v-model="lastName"><br>
                                        <p v-if="lastNameValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>
                                    <div>
                                        <input class="mt-4 w-full p-1 pl-2 rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)" :type="[showPassword ? 'text' : 'password']"  name="password" id="password" placeholder="Password" v-model="password">
                                        <span @click="showPassword = !showPassword">
                                            <i class="fa  -ml-8 mt-4" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                                        </span>
                                        <p v-if="passwordValidity === 'invalid'" class=" text-xs text-red-500">Password must contain at least one number and greater than 8 characters</p>
                                        
                                    </div>
                                    <div>
                                        <input class="mt-4 w-full p-1 pl-2 rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)" :type="[showPassword2 ? 'text' : 'password']"  name="confirm-password" id="confirm-password" placeholder="Confirm Password" v-model="confirmPassword">
                                        <span @click="showPassword2 = !showPassword2">
                                            <i class="fa  -ml-8 mt-4" :class="[showPassword2 ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                                        </span>
                                        <p v-if="confirmPasswordValidity === 'invalid'" class=" text-xs text-red-500">Password did not match</p>
                                        
                                    </div>
                            
                                    <div class="mt-4">
                                        <p>Date of Birth</p>
                                        <input class="mt-2 w-full p-1 pl-2 rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)" type="date" name="dob" id="dob" placeholder="Date of Birth" v-model="dob">
                                        <p v-if="dobValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>
                                    
                                    <div class="mt-2">
                                        <p>Gender</p>
                                        <select class="mt-2 w-full p-1 rounded-lg" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)"  name="gender" id="gender" v-model="gender">
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </select>
                                        <p v-if="genderValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>
                                    
                                    <div class=" mt-2">
                                        <p>Country</p>
                                        <select style="background-color:whitesmoke; border:1px solid rgb(18,84,179)"  class="w-full p-1 rounded-lg border pl-2 mt-1" name="countries" id="countries" v-model="country" @change="selectedCountry($event)">
                                            <option v-for="allCountry in countries" :key="allCountry" :value="allCountry">{{allCountry}}</option>
                                        </select>
                                        <p v-if="countryValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>

                                    <div class="mt-2">  
                                        <p>State</p>                                                 
                                        <select style="background-color:whitesmoke; border:1px solid rgb(18,84,179)"  class=" w-full p-1 rounded-lg border pl-2 mt-1"  name="state" id="state"  v-model="state" @change="selectedState($event)">
                                            <option v-for="allStates in states" :key="allStates" :value="allStates">{{allStates}}</option>
                                        </select> 
                                        <p v-if="stateValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty</p>                                      
                                    </div>
                                    
                                    <div>
                                        <div class="flex mt-5 text-sm">
                                            <input  type="checkbox" class="mt-2 mr-4" name="t&c" id="t&c" v-model="checkbox">
                                            <p>By creating an account, you are agreeing to our
                                                <a class="text-blue-500 cursor-pointer" @click="showPolicy">Terms of service</a> and <a @click="showPolicy" class="text-blue-500 cursor-pointer" to="/terms-policy">Privacy policy</a>
                                            </p>
                                            
                                        </div>
                                        <p v-if="checkValidity === 'invalid'" class=" text-xs text-red-500">Accept T&C to proceed</p>
                                    </div>
                                    
                                     <p  class=" text-xs text-red-500">{{error}}</p>
                                    <div class="mt-10 flex">
                                        <button class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)" >Proceed</button>
                                        <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                    </div>
                                </form>                              
                            </div>
                        </div>                        
                    </div>                   
                </div>               
            </div>
            <div class="image w-1/3 md:hidden">

            </div>
        </div>

        <div class="lg:hidden mt-16">
            <the-footer/>
        </div>

        <div>
            <TermsPolicyModal
            v-show="termsPolicy"
            @close="closeModal"
            />
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../../Config';
import TermsPolicyModal from '../TermsPolicyModal.vue';
const url = baseUrl;
export default {
    components:{TermsPolicyModal},
    data() {
        return {
            countryCode: [],
            countries: [],
            states: [],
            dsos: [],
            firstName: "",
            lastName: "",
            password: "",
            phoneNumber: this.$store.state.userPhone,
            dob: "",
            gender: "",
            country: "",
            state: "",
            checkbox: "",
            confirmPassword : "",
            selectedDso : "",
            

            firstNameValidity: "",
            lastNameValidity: "",
            passwordValidity: "",
            phoneValidity: "",
            dobValidity: "",
            genderValidity: "",
            countryValidity: "",
            stateValidity: "",
            selectedDsoValidity: "",
            checkValidity: "",
            isLoading: false,
            error: "",
            showPassword:false,
            showPassword2: false,
            confirmPasswordValidity: "",
            termsPolicy: false

        }
    },

    mounted() {
        this.get_countries();
        this.getDsos();
        this.networkError();
    },

    methods: {
        showPolicy() {
            this.termsPolicy = true;
        },
         closeModal() {
            this.termsPolicy = false;
        },
        selectedCountry(event){
            const selectedCountry = event.target.value;
            this.states = this.theCountries[selectedCountry]            
        },

        selectedState(event) {
            event.target.value;
        },
        onSelectedDso(event) {
            this.selectedDso = event.target.value;
        },

        get_countries() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/extras/countries`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
             .then((response) => {
                 this.countries =  Object.keys(response.data.data)
                 this.theCountries = response.data.data
             })
             .catch ((error) => {
                 console.log(error)
             })       
        },

        getDsos() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dsos`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
             .then((response) => {
                this.dsos =  response.data.data.results;
             })
             .catch ((error) => {
                 error
             })   
        },

        onPhoneNumber(event) {
            this.phoneNumber = event.target.value
        },

        // program to sort array by property name

        compareName(a, b) {

        // converting to uppercase to have case-insensitive comparison
        let name1;
        let name2;
        if(a.companyName) {
             name1 = a.companyName.toUpperCase();
        } else {
             name1 = a.firstName.toUpperCase();
        }
        if(b.companyName) {
             name2 = b.companyName.toUpperCase();
        } else {
             name2 = b.firstName.toUpperCase();
        }

        let comparison = 0;

        if (name1 > name2) {
            comparison = 1;
        } else if (name1 < name2) {
            comparison = -1;
        }
        return comparison;
        },

        submitDetails() {
            this.networkError();
            if(!this.firstName) {
                this.firstNameValidity = 'invalid';
                 setTimeout(() => {
                    this.firstNameValidity = "";
                }, 3000);
            } else if (!this.lastName) {
                this.lastNameValidity = 'invalid';
                 setTimeout(() => {
                    this.lastNameValidity = "";
                }, 3000);
            }  else if (!this.selectedDso) {
                this.selectedDsoValidity = 'invalid';
                 setTimeout(() => {
                    this.selectedDsoValidity = "";
                }, 3000);
            } else if(!this.password || this.password.length < 8 || this.password.search(/[0-9]/) < 0) {
                this.passwordValidity = 'invalid';
                 setTimeout(() => {
                    this.passwordValidity = "";
                }, 3000);
            } else if(this.confirmPassword !== this.password){
                this.confirmPasswordValidity = 'invalid';
                 setTimeout(() => {
                    this.confirmPasswordValidity = "";
                }, 3000);
            }else if (!this.gender) {
                this.genderValidity = 'invalid';
                 setTimeout(() => {
                    this.genderValidity = "";
                }, 3000);
            } else if (!this.dob) {
                this.dobValidity = 'invalid';
                 setTimeout(() => {
                    this.dobValidity = "";
                }, 3000);
            } else if(!this.country) {
                this.countryValidity = 'invalid';
                 setTimeout(() => {
                    this.countryValidity = "";
                }, 3000);
            } else if (!this.state) {
                this.stateValidity = 'invalid';
                 setTimeout(() => {
                    this.stateValidity = "";
                }, 3000);
            } else if(!this.checkbox) {
                this.checkValidity = 'invalid';
                 setTimeout(() => {
                    this.checkValidity = "";
                }, 3000);
            } 
            else {
                this.isLoading = true;
                axios({
                method: "POST",
                url: `${url}/v1/web/riders/dso/create`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data: {
                    dsoId : String(this.selectedDso),
                    firstName: String(this.firstName),
                    lastName: String(this.lastName),
                    email: String(localStorage.getItem("riderEmail")),
                    password: String(this.password),
                    phone: String(localStorage.getItem("riderPhone")),
                    dob: String(this.dob),
                    gender: String(this.gender),
                    country: String(this.country),
                    state: String(this.state),
                }
                })
                .then((res) => {
                    this.$store.commit("setAuthentication", true)            
                    res;
                    this.isLoading = false;
                    this.$router.push("/dsoRider-step3-registration")
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                     setTimeout(() => {
                    this.error = "";
                }, 3000);
                    this.isLoading = false;
                })
            }
        },
        networkError() {
        if(!navigator.onLine) {
            this.$router.push('/network-error')
        } 
    }
    }
}
</script>

<style scoped>
.image {
    background-image: url("../Image/sea.png");
    background-repeat: no-repeat;
}
</style>
